export default __webpack_public_path__ + "static/media/cern-regular.5192f941.woff2";